import { render, staticRenderFns } from "./TaxTemplatePop.vue?vue&type=template&id=b1e0fb8c"
import script from "./TaxTemplatePop.vue?vue&type=script&lang=js"
export * from "./TaxTemplatePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e0fb8c')) {
      api.createRecord('b1e0fb8c', component.options)
    } else {
      api.reload('b1e0fb8c', component.options)
    }
    module.hot.accept("./TaxTemplatePop.vue?vue&type=template&id=b1e0fb8c", function () {
      api.rerender('b1e0fb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/TaxTemplatePop.vue"
export default component.exports